document.addEventListener("DOMContentLoaded", () => {
    if (!document.querySelector(".aside-float__stiky")) return;

    if (window.innerWidth < 992) return;

    let lastScrollY = scrollY,
        lastDirection = false,
        scrollDirection = false,
        winWidth = document.documentElement.clientWidth,
        winHeight = window.innerHeight,
        aside = document.querySelector(".aside-float"), // полоска внутри которой двигается блок
        asideRect = aside.getBoundingClientRect(),
        stiky = document.querySelector(".aside-float__stiky"), // двигающийся блок
        stickyRect = stiky.getBoundingClientRect(),
        products = document.querySelector(".catalog-category-block .row"), // товары
        productsRect = products.getBoundingClientRect(),
        styles = {},
        tGap = document.querySelector(".header").clientHeight + 10, // граница сверху (фиксированные блоки (шапки), отступ от края экрана)
        bGap = 10, // граница снизу (отступ от края экрана)
        tEdge = 0,
        bEdge = 0;

    document.addEventListener("scroll", () => {
        scrollDirection = scrollY < lastScrollY ? "up" : "down";
        winWidth = document.documentElement.clientWidth;
        winHeight = window.innerHeight;

        asideRect = aside.getBoundingClientRect();
        stickyRect = stiky.getBoundingClientRect();
        productsRect = products.getBoundingClientRect();

        tEdge = asideRect.top;
        bEdge = asideRect.top + asideRect.height - stickyRect.height;

        // если ползающий блок больше списка товаров и его не нужно двигать
        if (productsRect.height < stickyRect.height) return false;

        // если ползающий блок влезает в отведенный экран
        if (stickyRect.height < winHeight - tGap - bGap) {
            if (stickyRect.top <= tGap) {
                styles.position = "fixed";
                styles.top = tGap + "px";

                if (parseFloat(styles.top) <= tEdge) {
                    styles.position = "absolute";
                    styles.top = 0;
                }
                if (
                    stickyRect.height + parseFloat(styles.top) >=
                    asideRect.height + asideRect.top
                ) {
                    styles.position = "fixed";
                    styles.top = bEdge + "px";
                }
            }
        }
        // если ползающий блок не влезает в отведенный экран
        else {
            if (lastDirection && lastDirection != scrollDirection) {
                styles.position = "absolute";
                styles.top = stickyRect.top - asideRect.top + "px";
            }

            if (
                scrollDirection == "down" &&
                (stickyRect.top + stickyRect.height <= winHeight - bGap ||
                    stickyRect.height + stickyRect.top >=
                        asideRect.height + asideRect.top)
            ) {
                styles.position = "fixed";
                styles.top = winHeight - stickyRect.height - bGap + "px";

                if (
                    stickyRect.height + parseFloat(styles.top) >=
                    asideRect.height + asideRect.top
                ) {
                    styles.top = bEdge + "px";
                }
            }

            if (
                scrollDirection == "up" &&
                (stickyRect.top >= 0 + tGap || stickyRect.top <= tEdge)
            ) {
                styles.position = "fixed";
                styles.top = 0 + tGap + "px";

                if (parseFloat(styles.top) <= tEdge) {
                    styles.top = tEdge + "px";
                }
            }
        }

        if (styles.position == "absolute") {
            styles.left = 0;
            styles.right = 0;
        }
        if (styles.position == "fixed") {
            styles.left = asideRect.left + "px";
            styles.right = winWidth - asideRect.left - asideRect.width + "px";
        }

        Object.assign(stiky.style, styles);

        lastDirection = scrollY < lastScrollY ? "up" : "down";
        lastScrollY = scrollY;
    });
});
